import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { localizedDayjs } from 'tradera/utils/date';

export const useDayJs = () => {
    const preferredLanguageCodeIso2 = useSelector(
        (state) => state.language.preferred.languageCodeIso2
    );
    const localizedDayjsCallback = useCallback(
        (...args) => localizedDayjs(preferredLanguageCodeIso2)(...args),
        [preferredLanguageCodeIso2]
    );
    return localizedDayjsCallback;
};
